import { ColumnType } from './types';

export function filterConfig<RecordType>(config: ColumnType<RecordType>[]): ColumnType<RecordType>[] {
  return config.reduce((filteredConfig, group) => {
    if (!group.children) {
      if (group.enabled !== false) {
        return [...filteredConfig, group];
      }
      return filteredConfig;
    }
    if (!group.children.some((column) => column.enabled !== false)) {
      return filteredConfig;
    }
    return [
      ...filteredConfig,
      {
        ...group,
        children: group.children.filter((column) => column.enabled !== false),
      },
    ];
  }, [] as ColumnType<RecordType>[]);
}
